import { render, staticRenderFns } from "./PrivacyPigYear.vue?vue&type=template&id=77c7ca3c&scoped=true"
import script from "./PrivacyPigYear.vue?vue&type=script&lang=js"
export * from "./PrivacyPigYear.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPigYear.vue?vue&type=style&index=0&id=77c7ca3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c7ca3c",
  null
  
)

export default component.exports